import Home from './home'
import Account from './account'
import Settings from './settings'
import Insight from './insight'
import Investment from './investment'
import Borrow from './borrow'
import Lifestyle from './lifestyle'
import Support from './support'
import Transactions from './transactions'
import InsightTransactions from './insightTransactions'
import Faq from './support/faq'
import Cbp from './cbp'


export default [
    Home,
    Account,
    Settings,
    Insight,
    Investment,
    Borrow,
    Lifestyle,
    Support,
    Transactions,
    InsightTransactions,
    Faq,
    Cbp
]